import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { Grid, TextField, IconButton } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import AddCommentIcon from "../../../icons/AddCommentIcon"
import { addComment } from "../../../../actions/documentsActions"
import { LOCAL_STORAGE_KEYS } from "../../../../utils"

const useStyles = makeStyles((theme) => ({
	root: {
		padding: "2px 4px",
		position: "absoulte",
		bottom: 0,
	},
	input: {
		border: `1px solid ${theme.palette.grey["D400"]}`,
		width: "100%",
		height: 40,
		padding: "2px 4px",
	},
	iconButton: {
		padding: 0,
	},
}))

function AddComment(props) {
	const classes = useStyles()
	const [isCommentBtnDisabled, setCommentBtnDisabled] = useState(false)
	const [commentText, setCommentText] = useState("")
	const [commentId, setCommentId] = useState("")
	const dispatch = useDispatch()
	const [t] = useTranslation("global")
	const inputRef = React.useRef()

	const handleChange = (e) => {
		if (e.target.value?.trim()) {
			setCommentBtnDisabled(true)
		} else {
			setCommentBtnDisabled(false)
		}
		setCommentText(e.target.value)
	}

	const handleSubmit = () => {
		const documentId = props?.docId
		if (commentText && documentId && commentId) {
			dispatch(addComment(documentId, commentText, commentId))
		} else if (commentText && documentId) {
			dispatch(addComment(documentId, commentText))
			//register comment is added
			localStorage.setItem(LOCAL_STORAGE_KEYS.TRIGGER_P_SEARCH, true)
		}
		resetCommentForm()
	}

	const resetCommentForm = () => {
		setCommentText("")
		setCommentBtnDisabled(false)
		setCommentId("")
	}

	useEffect(() => {
		const timeout = setTimeout(() => {
			inputRef.current.focus()
		}, 100)
		if (!_.isEmpty(props?.editComment)) {
			setCommentText(props?.editComment?.comment)
			setCommentId(props?.editComment?.commentId)
			setCommentBtnDisabled(false)
		}
	}, [props?.editComment])

	return (
		<form className={classes.root} noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
			<Grid container spacing={2} style={{ marginTop: 5 }}>
				<Grid item xs={12} sm={12} md={10}>
					<TextField
						autoFocus
						className={classes.input}
						placeholder={t("viewer.tabs.comment.input.placeholder")}
						InputProps={{ disableUnderline: true }}
						onChange={handleChange}
						value={commentText}
						inputRef={inputRef}
					/>
				</Grid>
				<Grid item xs={12} sm={12} md={2}>
					<IconButton
						className={classes.iconButton}
						style={{ opacity: isCommentBtnDisabled ? 1 : 0.3 }}
						disabled={!isCommentBtnDisabled}
						onClick={handleSubmit}
					>
						<AddCommentIcon />
					</IconButton>
				</Grid>
			</Grid>
		</form>
	)
}

export default AddComment
